import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {Link} from 'react-router';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AppPanel from '../fw/AppPanel.react';
import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import RefreshButton from './../jobs/RefreshButton.react';
import {FormattedMessage} from 'react-intl';
import {renderTime} from './FlowInvocationList.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import FlowInvocationStatus from './FlowInvocationStatus.react';

const messages = defineMessages({
    title: {id: 'flowInvocationsList.title', 'defaultMessage': 'Flow Invocations'},
    createdAtAfter: {id: 'flowInvocationsList.createdAtAfter', 'defaultMessage': 'Created after'},
    createdAtBefore: {id: 'flowInvocationsList.createdAtBefore', 'defaultMessage': 'Created before'}
});

class FlowInvocationListOrganisation extends React.Component {

    typeName = 'flowInvocations';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    listUrlPart = 'list-org';

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            loadingError: false,
            sortDesc: true,
        };
    }

    search = (event) => {
        this.setState({
            loading: true,
            loadingError: false,
        });

        let values = {};

        if (this.refs.createdAtBeforeBoxRef.value) {
            let time = this.refs.createdAtBeforeTimeBoxRef.value || "23:59:59";
            values["createdAtBefore"] = this.refs.createdAtBeforeBoxRef.value + " " + time;
        }
        if (this.refs.createdAtAfterBoxRef.value) {
            let time = this.refs.createdAtAfterTimeBoxRef.value || "00:00:00";
            values["createdAtAfter"] = this.refs.createdAtAfterBoxRef.value + " " + time;
        }

        this.props.relay.setVariables(values, (state) => {
            if (state.done) {
                this.setState({
                    loading: false,
                    loadingError: false,
                });
            } else if (state.error) {
                this.setState({
                    loading: false,
                    loadingError: true,
                });
            }
        });
    }

    reset = () => {
        if (this.refs.createdAtAfterBoxRef) {
            this.refs.createdAtAfterBoxRef.value = "";
        }
        if (this.refs.createdAtBeforeBoxRef) {
            this.refs.createdAtBeforeBoxRef.value = "";
        }
        if (this.refs.createdAtAfterTimeBoxRef) {
            this.refs.createdAtAfterTimeBoxRef.value = "";
        }
        if (this.refs.createdAtBeforeTimeBoxRef) {
            this.refs.createdAtBeforeTimeBoxRef.value = "";
        }
        this.props.relay.setVariables({
            createdAtAfter: "",
            createdAtBefore: "",
            failed: null,
            startType: null,
        });
    }

    toggleSort = (sortDesc) => {
        this.setState({ loading: true, loadingError: false, sortDesc });
        const values = {
            after: null,
            before: null,
            first: defaultPageSize,
            last: null,
            orderBy: sortDesc ? 'createdAt desc' : 'createdAt asc',
        };
        const applyDone = (state) => {
            if (state.done) {
                this.setState({ loading: false });
            } else if (state.error) {
                this.setState({ loading: false, loadingError: true });
            }
        };
        if (this.props.relay && this.props.relay.setVariables) {
            this.props.relay.setVariables(values, applyDone);
        } else if (this.props.relay && this.props.relay.forceFetch) {
            this.props.relay.forceFetch(values, applyDone);
        }
    };

    render() {
        let { user } = this.props;
        let data = user.organisation;
        let list = data.flowInvocations;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } className="fetchList" title={this.props.intl.formatMessage(messages.title)}>
                <h3><FormattedMessage defaultMessage="Flow Invocation History" id="flow.flowInvocationTitle" /></h3>

                <div className="btn-toolbar" role="toolbar">
                    <RefreshButton autoRefresh relay={this.props.relay} />

                    <div aria-label="..." className="btn-group" role="group" style={{paddingRight: '1em'}}>
                        <Link activeClassName="active" className="btn btn-default" onlyActiveOnIndex to={urlMapping.getUrl(type, this.listUrlPart, data)}><FormattedMessage defaultMessage="All" id="invocationList.listAll" /></Link>
                        <Link activeClassName="active" className="btn btn-default" onlyActiveOnIndex to={urlMapping.getUrl(type, this.listUrlPart + '-success', data)}><FormattedMessage defaultMessage="Succeeded" id="invocationList.listSuccess" /></Link>
                        <Link activeClassName="active" className="btn btn-default" onlyActiveOnIndex to={urlMapping.getUrl(type, this.listUrlPart + '-fail', data)}><FormattedMessage defaultMessage="Failed" id="invocationList.listFailed" /></Link>
                    </div>

                    <div className="input-group" style={{maxWidth: '200px'}}>
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtAfter)} ref="createdAtAfterBoxRef" type="date" />
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtAfter)} ref="createdAtAfterTimeBoxRef" style={{width: '5em'}} type="time" />
                    </div>
                    <div className="input-group" style={{maxWidth: '200px'}}>
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtBefore)} ref="createdAtBeforeBoxRef" type="date" />
                        <input className="form-control" name="search" placeholder={this.props.intl.formatMessage(messages.createdAtBefore)} ref="createdAtBeforeTimeBoxRef" style={{width: '5em'}} type="time" />
                    </div>
                    <div aria-label="..." className="btn-group" role="group" style={{paddingRight: '1em'}}>
                        <div className="input-group-btn">
                            <button className="btn btn-outline-secondary" onClick={this.search} type="button">{this.state.loading ? <span className="fa fa-refresh fa-spin"/> : (this.state.loadingError ? <span className="fa fa-exclamation" style={{color: 'red'}}/> : <span className="fa fa-search"/>)}</button>
                        </div>
                        <div className="input-group-btn">
                            <button className="btn btn-outline-secondary" onClick={this.reset} type="button"><span className="fa fa-times"/></button>
                        </div>
                    </div>
                </div>

                <PagingGrid
                        columns={{
                            'startType': {},
                            'flowStepDef.name': {},
                            'createdAt': {
                                header: (
                                    <span onClick={() => { if (!(this.state.loading || (this.props.relay && this.props.relay.pendingVariables))) this.toggleSort(!this.state.sortDesc); }} style={{cursor: (this.state.loading || (this.props.relay && this.props.relay.pendingVariables)) ? 'not-allowed' : 'pointer'}}>
                                        <FormattedMessage defaultMessage="Created at" id="flowInvocationsList.createdAt" />
                                        {this.state.loading ? <span className="fa fa-refresh fa-spin" style={{marginLeft: '0.5em'}}/> : (
                                            this.state.sortDesc ? <span className="fa fa-long-arrow-down" style={{marginLeft: '0.5em'}}/> : <span className="fa fa-long-arrow-up" style={{marginLeft: '0.5em'}}/>
                                        )}
                                    </span>
                                ),
                                render: (column, item) => {
                                    return renderTime(item, column);
                                }
                            },
                            'priority': {
                            },
                            'lastRun': {
                                render: (column, item) => {
                                    return renderTime(item, column);
                                }
                            },
                            'apiCount': {},
                            'currentProgress': {
                                header: <span></span>,
                                render: (column, item) => {
                                    return (<FlowInvocationStatus flowInvocation={item} />);
                                }
                            },
                        }}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping}
                    />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(FlowInvocationListOrganisation), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
        failed: null,
        createdAtBefore: null,
        createdAtAfter: null,
        orderBy: 'createdAt desc',
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        if (variables.failed) {
            if (variables.failed === "fail") {
                variables.failed = true;
            } else {
                variables.failed = false;
            }
        }
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    flowInvocations(first: $first, after: $after, before: $before, last: $last, failed: $failed, createdAtBefore: $createdAtBefore, createdAtAfter: $createdAtAfter, orderBy: $orderBy) {
                        edges {
                            node {
                                id,
                                realId,
                                organisation_id,
                                flow_id,
                                flowStepDef {
                                    id,
                                    realId,
                                    name,
                                },
                                startType,
                                ${FlowInvocationStatus.getFragment("flowInvocation")},
                                finished,
                                failed,
                                apiCount,
                                nextRetry,
                                lastRun,
                                createdAt,
                                priority,
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
                }
            }
        `,
    },
});
